import { IconFormNames } from './icon-names';

export enum IconCategory {
  WorkAndCareer = 'work-and-career',
  Sport = 'sport',
  Health = 'health',
  MoneyAndFinance = 'money-and-finance',
  FunAndRelaxation = 'fun-and-relaxation',
  EducationAndLearning = 'education-and-learning',
  FamilyAndFriends = 'family-and-friends',
  LoveAndRelationships = 'love-and-relationships',
  Spirituality = 'spirituality',
  Other = 'other',
}

export type IconCategoryListItem = {
  category: IconCategory;
  icons: IconFormNames[];
};
